import Swal from "sweetalert2";
import { syncLocalCartData } from "./AddToCart";

export function showMessage({ status, message }) {
  Swal.fire({
    icon: status,
    title: message,
  }).then((result) => {
    // If user clicks OK
    if (result.isConfirmed) {
      console.log("Do Nothing");
    }
  });
}

export async function loginShowMessage(Response) {
  await Swal.fire({
    icon: Response.status,
    title: Response.message,
    footer: '<a href="/login-guide">Why do I have this issue?</a>',
    confirmButtonText: "Continue",
  });

  if (Response.status !== "success") return;

  try {
    // 1️⃣ Save token AFTER sync
    localStorage.setItem("token", Response.token);

    // 2️⃣ Sync local cart → DB (WAIT for it)
    const SyncResult = await syncLocalCartData();
    if (SyncResult.data.status == "success") {
      // 3️⃣ Clear local cart AFTER successful sync
      localStorage.removeItem("user_temp_cart");
      // 4️⃣ Redirect (safe now)
      window.location.href = "/dashboard";
    }
  } catch (err) {
    console.error("Cart sync failed:", err);
  }
}
